(function ($) {
  Drupal.behaviors.desire_products_mob_v1 = {
    attach: function (context) {
      $('#desire_mod3', context).once(function () {
        var thisModuleName = 'desire_mod3';
        var triggerMod = '#desire_mod3';
        var $thismodule = $('#desire_mod3');
        // If module is called in URL, scroll to module.
        var urlHash = window.location.href.split('#')[1];
        // Background Color
        var moduleBackground = $thismodule.data('module-background') || 'dark';
        // Fade in
        var moduleWillFade = false;
        var hasFaded = false;
        // Init scrollMagic Controller Class
        var controller = new ScrollMagic.Controller();
        var offset;
        // Mobile Quickshop
        var mppTarget, targetQSOpen_1, targetQSClose_1;
        var targetAttach = $thismodule.find('.desire_mod3_mpp');
        var mppTargetExists;
        // Set the parallax duration
        var windowHeight = $(window).height();
        var parallaxDuration = windowHeight / 1.1;
        var desire_mod3_scene1;
        var fadeThisModuleScene;

        urlHashCheck();

        function urlHashCheck() {
          if (urlHash === thisModuleName) {
            $('html,body').animate(
              {
                scrollTop: $thismodule.offset().top - 85
              },
              1500
            );
          }
        }

        // Apply a css class to the module wrapper based on background in data-module-background
        $thismodule
          .parent()
          .parent()
          .addClass('desire__module-' + moduleBackground + '-bg');

        // Set the scene/
        desire_mod3_scene1 = new ScrollMagic.Scene({
          triggerElement: '#desire_mod3',
          offset: -150,
          duration: parallaxDuration
        })
          .setTween('.js-desire_mod3__parallax', 8, {
            top: '-49%',
            ease: Linear.easeNone
          })
          .addTo(controller);

        // Apply a css class to the module wrapper based on background in data-module-background
        $thismodule
          .parent()
          .parent()
          .addClass('desire__module-' + moduleBackground + '-bg');

        // Append Quickshop.
        mppTargetExists = false;
        checkMppParent();
        function checkMppParent() {
          if ($thismodule.parents('.node-elc-nodeblock').length) {
            mppTarget = $thismodule.parents().eq(3).prev('.mpp');
            mppTargetExists = true;
          } else {
            mppTarget = $thismodule.parent().prev('.mpp');
            mppTargetExists = true;
          }
        }

        function setupQuickshop() {
          targetAttach = $thismodule.find('.desire_mod3_mpp');
          targetQSOpen_1 = mppTarget.find(
            'a.button__quickshop.product-brief__button-quickshop.js-quickshop-show'
          );
          targetQSClose_1 = mppTarget.find(
            'a.product-brief__button-quickshop--close.js-quickshop-hide'
          );
          // Add styling to open and close quickshop button
          targetQSOpen_1.addClass('shop_now_dark shop_now_centered');
          targetQSClose_1.addClass('shop_now_light shop_now_white shop_now_centered');
        }
        if (mppTargetExists === true) {
          setupQuickshop();
        }

        function finishQuickshop() {
          mppTarget.addClass('mpp_qs_detached');
          // Moving quickshop element to within module 3
          mppTarget.detach().insertAfter(targetAttach);
          $('#desire_mod3 .mpp_qs_detached .mpp__product-grid .product-brief.left').detach();
          // Moving quickshop buttons to within module 3
          targetQSOpen_1.detach().appendTo(targetAttach);
          targetQSClose_1.detach().appendTo(targetAttach);
        }

        $(window).on('load', function () {
          // Append Quickshop.
          if (mppTargetExists === true) {
            finishQuickshop();
          }
        });
        // Check if Content Author has specified for module
        // to fade in.
        if ($thismodule.data('scrollmagic') === 1) {
          moduleWillFade = true;
          // Hide and push down the module if it is to be faded in.
          $thismodule.addClass('hideModules');
        }

        // Handle module fade-in from CMS.
        function fadeThisModule() {
          if (hasFaded === false) {
            hasFaded = true;
            $thismodule.animate(
              {
                opacity: 1,
                paddingTop: '0'
              },
              350,
              'easeOutQuad'
            );
          } else {
            return;
          }
        }

        // Content-Author-managed - Module Fade.
        if (moduleWillFade) {
          // Set the offset.
          if ($thismodule.data('offset')) {
            offset = $thismodule.data('offset');
          } else {
            offset = 0;
          }

          // Init scrollMagic Scene Class
          fadeThisModuleScene = new ScrollMagic.Scene({
            triggerElement: triggerMod,
            offset: offset
          }).on('start', function () {
            fadeThisModule();
          });
          controller.addScene([fadeThisModuleScene]);
        }
      });
    }
  };
})(jQuery);
